<template>
    <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card">
            <div class="card-header">
                <div class="d-md-flex align-items-center">
                    <div>
                        <h4 class="card-title"><i class="fas fa-handshake"></i> Partnership Type: {{partnership.type | capitalize}}</h4>
                        <h6 class="card-subtitle">Partnership details</h6>
                    </div>
                    <div class="ml-auto d-flex no-block align-items-center">
                        <div class="dl">
                            <div class="button-group">
                                <router-link :to="{name: 'parnershiptype'}" class="btn btn-outline-secondary waves-effect waves-light"><i class="fas fa-arrow-circle-left"></i> Back</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body card-blue">
                <div class="form-group row">
                    <label class="control-label text-right col-md-3">Name:</label>
                    <div class="col-md-9">
                        <p class="form-control-static"> {{partnership.name}} </p>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="control-label text-right col-md-3">Description:</label>
                    <div class="col-md-9">
                        <p class="form-control-static"> {{partnership.description}} </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                <div class="d-md-flex align-items-center">
                    <div>
                        <h4 class="card-title"><i class=" fas fa-users"></i> Partners</h4>
                        <h6 class="card-subtitle">Add / Remove Partner</h6>
                    </div>

                    <div class="ml-auto d-flex no-block align-items-center">
                        <div class="dl">
                            <div class="button-group">
                                <button @click="openAddMemberModal()" class="btn waves-effect waves-light btn-success" data-target="#addMemberModal" data-toggle="modal" type="button">
                                    <i class="fas fa-user-plus"></i> &nbsp;Add Partner
                                </button>
                                <div aria-hidden="true" aria-labelledby="addMemberModal" class="modal fade" id="addMemberModal" role="dialog" tabindex="-1">
                                    <div class="modal-dialog modal-lg">
                                        <div class="modal-content text-left">
                                            <div class="modal-body p-0">
                                                <div class="card card-blue m-b-0">
                                                    <div class="card-header">
                                                        <h4 class="card-title">Partnership Type: {{partnership.type | capitalize}}</h4>
                                                        <h6 class="card-subtitle">Select a new partnership type to continue</h6>
                                                    </div>
                                                    <form @submit.prevent="handlePartnerSubmit('members-form')" class="form-horizontal" data-vv-scope="members-form">
                                                        <div class="card-body">
                                                            <div class="form-group row">
                                                                <label class="control-label text-right col-md-3" for="partners">Select Partner:</label>
                                                                <div class="col-md-7">
                                                                    <multiselect
                                                                            :class="{'is-invalid': submitted && errors.has('members-form.allPartners')}"
                                                                            :clear-on-select="false"
                                                                            :close-on-select="true"
                                                                            :hide-selected="true"
                                                                            :internal-search="false"
                                                                            :limit="3"
                                                                            :loading="isLoading"
                                                                            :max-height="600"
                                                                            :options="allPartners"
                                                                            :options-limit="300"
                                                                            :searchable="true"
                                                                            :show-no-results="false"
                                                                            @search-change="getPartners"
                                                                            data-vv-as="partners"
                                                                            id="partners"
                                                                            class="form-control"
                                                                            label="partners"
                                                                            name="partners"
                                                                            open-direction="bottom"
                                                                            placeholder="Search Partners"
                                                                            track-by="id"
                                                                            v-model="newPartner"
                                                                            v-validate="'required'">
                                                                        <template slot="singleLabel" slot-scope="props">
                                                                            <div class="option__desc">
                                                                                <div class="option__desc">
                                                                                    <h5>{{ props.option.biz_name }}</h5>
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                        <template slot="option" slot-scope="props">
                                                                            <div class="option__desc">
                                                                                <div class="option__desc">
                                                                                    <h4>{{ props.option.biz_name }}</h4>
                                                                                    <h6>{{ props.option.line1 +', '+ props.option.city+', '+ props.option.country}}</h6>
                                                                                </div>
                                                                            </div>
                                                                        </template>
                                                                    </multiselect>
                                                                    <div class="invalid-feedback" v-if="submitted && errors.has('members-form.allPartners')">{{ errors.first('members-form.allPartners') }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="card-footer text-right">
                                                            <button class="btn waves-effect waves-light btn-success m-r-15" type="submit">Submit</button>
                                                            <button class="btn waves-effect waves-light btn-secondary" data-dismiss="modal" type="button">Cancel</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body card-blue">

                <!-- Tab panes -->
                <div class="tab-content" v-if="partners.length >0 && partners[0].id">
                    <div class="table-responsive">
                        <table class="table no-wrap v-middle">
                            <thead>
                            <tr class="border-0">
                                <th class="border-0">#</th>
                                <th class="border-0">Partner</th>
                                <th class="border-0">Partnership Since</th>
                                <th class="border-0">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-bind:key="index" v-for="(p, index) in partners">
                                <td>{{index+1}}</td>
                                <td>{{p.name}}</td>
                                <td>{{p.partnership_date | medium}}</td>
                                <td>
                                    <a class="text-danger" data-target="#confirmModal" data-toggle="modal" href="javasript:void(0);"><b>Remove</b></a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <paginate
                            :click-handler="pageHandler"
                            :container-class="'pagination float-right'"
                            :margin-pages="2"
                            :next-class="'page-link'"
                            :next-text="'Next'"
                            :page-class="'page-link'"
                            :page-count=pageCount
                            :page-range="3"
                            :prev-class="'page-link'"
                            :prev-text="'Prev'">
                    </paginate>
                </div>
                <div class="tab-content" v-else>
                    <h4 class="card-title text-muted text-center m-30">No records found</h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Paginate from 'vuejs-paginate';
    import Multiselect from 'vue-multiselect';

    export default {
        name: "ViewPartnershipType",
        props: ["partnershipid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Paginate, Multiselect},
        data() {
            return {
                isLoading: false,
                submitted: false,
                total: 0,
                pageCount: 1,
                partnership: [],
                partners: [],
                allPartners: [],
                newPartner: [],
                pageCount: 1,
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getPartnershipType(1);
            },
            async getPartnershipType(page) {
                try {
                    $(".preloader").fadeIn();
                    let reply        = await this.$http
                    .get("/express/" + this.currentOrg.express_id + "/partnership/" + this.partnershipid, {
                        params: {
                            page: page,
                            perPage: 10
                        }
                    });
                    $(".preloader").fadeOut();
                    this.total       = reply.data.total;
                    this.partnership = reply.data.partnership;
                    this.partners    = reply.data.partnership.orgs;
                } catch(e) {
                    $(".preloader").fadeOut();
                    console.log(err);
                }
            },
            setPageCount() {
                this.pageCount = this.total <= 10 ? 1 : Math.ceil(this.total / 10);
            },
            pageHandler(pageNum) {
                this.getPlanMembers(pageNum);
            },
            async getPartners(searchText) {
                try {
                    this.isLoading   = true;
                    let reply        = await this.$http.get("/express/" + this.currentOrg.express_id + "/partner/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.allPartners = reply.data;
                    this.isLoading   = false;
                } catch(e) {
                    console.log(err);
                }
            },
            async handlePartnerSubmit(scope) {
                this.submitted = true;
                // this.$validator.validateAll(scope)
                // .then(valid => {
                //     if(valid) {
                //         this.retirePlan();
                //     }
                // });
            },
            openAddMemberModal() {
                this.submitted   = false;
                this.newPartner  = [];
                this.allPartners = [];
            },
            limitText(count) {
                return `and ${count} more users.`
            },
        }
    }
</script>

<style scoped>

</style>
